/* loop + twist Fabric Colourway Switcher (OTHER, Sep 2026). Full commented source: project docs fabric-visualiser/colourway-switcher.js */
(function () {
  'use strict';
  var CONFIG = {
    swatchLabel: '.tpo_image-swatches-wrapper label',
    swatchInput: 'input.tpo_image-swatches-input',
    mainImageSelector:
      'product-gallery:not([style*="display: none"]) .product-gallery__media img, ' +
      '.product-gallery__media img, .product__media img, ' +
      '.product-single__photo img, [data-product-image] img',
    widths: [400, 600, 800, 1000, 1200, 1400, 1600, 1800, 2000],
    initDelay: 600,
    rerenderDelays: [400, 1000],
    preload: true,
    preloadWidth: 800,
    debug: false
  };
  var RAW = window.LT_COLOURWAYS || null;
  var VARIANTS = window.LT_VARIANTS || null;
  var BASE_IMAGE = window.LT_BASE_IMAGE || null;
  var NATIVE = window.LT_STANDARD_UPHOLSTERY || '';
  if (!RAW || typeof RAW !== 'object' || !Object.keys(RAW).length) return;
  if (/[?&]lt_debug=1/.test(location.search)) CONFIG.debug = true;

  function log() {
    if (!CONFIG.debug) return;
    var a = Array.prototype.slice.call(arguments); a.unshift('[lt-colourway]');
    console.log.apply(console, a);
  }
  /* Easify uses an EN DASH between name and code (Velvet uses a hyphen) and Boucle carries an accent. Do not simplify. */
  function normalise(s) {
    return (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9\s]/gi, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  /* Two shapes of map:
       flat   { "Velvet Merlot Red - 053": url, ... }               one set of renders for the whole product
       nested { "Single 80 CM": { "Bouclé Charcoal – 003": url } }   renders that differ per variant option
     A nested map is keyed on one Shopify variant option value (teddy modular sofa: Segment Selection).
     Which option that is, is worked out by matching the map's top level keys against the selected variant. */
  var firstKey = Object.keys(RAW)[0];
  var NESTED = !!(RAW[firstKey] && typeof RAW[firstKey] === 'object');
  var NATIVE_KEY = normalise(NATIVE);
  var LOOKUP = {};
  var mapKeyIndex = -1;

  function currentVariantId() {
    var el = document.querySelector('input[name="id"], select[name="id"]');
    return el ? String(el.value) : '';
  }
  function currentVariant() {
    return (VARIANTS && VARIANTS[currentVariantId()]) || null;
  }
  function currentOptions() {
    var v = currentVariant();
    if (v && v.o) return v.o.filter(Boolean);
    /* Fallback if the snippet did not output LT_VARIANTS: the variant picker prints the chosen value next to its legend */
    return [].map.call(document.querySelectorAll('.variant-picker__option-info span'), function (s) {
      return s.textContent.trim();
    }).filter(Boolean);
  }
  function activeMap() {
    if (!NESTED) return RAW;
    var opts = currentOptions();
    var keys = Object.keys(RAW);
    for (var i = 0; i < opts.length; i++) {
      for (var j = 0; j < keys.length; j++) {
        if (normalise(keys[j]) === normalise(opts[i])) { mapKeyIndex = i; return RAW[keys[j]]; }
      }
    }
    log('no sub-map for the selected variant', opts);
    return null;
  }
  function buildLookup() {
    LOOKUP = {};
    var m = activeMap();
    if (m) Object.keys(m).forEach(function (k) { LOOKUP[normalise(k)] = m[k]; });
    log('lookup rebuilt,', Object.keys(LOOKUP).length, 'colourways for', currentOptions().join(' / '));
  }

  /* input.value = colour, input.name = "<uuid>,<Fabric>" : fabric is the LAST comma segment */
  function parseSwatch(label) {
    var input = label.querySelector(CONFIG.swatchInput);
    if (!input) return null;
    var colourName = (input.value || '').trim();
    if (!colourName) return null;
    var parts = (input.name || '').split(',');
    return { colourName: colourName, fabricType: parts.length > 1 ? parts[parts.length - 1].trim() : '' };
  }
  function findImage(sw) {
    var keys = [normalise(sw.fabricType + ' ' + sw.colourName), normalise(sw.colourName + ' ' + sw.fabricType), normalise(sw.colourName)];
    for (var i = 0; i < keys.length; i++) {
      if (LOOKUP[keys[i]]) { log('matched', keys[i]); return LOOKUP[keys[i]]; }
    }
    log('no match', keys);
    return null;
  }
  function isNative(sw) {
    if (!NATIVE_KEY) return false;
    return NATIVE_KEY === normalise(sw.fabricType + ' ' + sw.colourName) || NATIVE_KEY === normalise(sw.colourName + ' ' + sw.fabricType);
  }
  function getHero() { return document.querySelector(CONFIG.mainImageSelector); }
  /* Update src, srcset, data-src and <picture> sources or breakpoints keep a cached image */
  function swapHero(url) {
    var img = getHero();
    if (!img || !url) return false;
    var base = url.split('?')[0];
    var srcset = CONFIG.widths.map(function (w) { return base + '?width=' + w + ' ' + w + 'w'; }).join(', ');
    img.src = base + '?width=2000';
    img.srcset = srcset;
    if (img.dataset && img.dataset.src) img.dataset.src = base + '?width=2000';
    img.removeAttribute('loading');
    var pic = img.closest && img.closest('picture');
    if (pic) pic.querySelectorAll('source').forEach(function (s) { s.srcset = srcset; });
    log('swapped', base);
    return true;
  }
  /* The photograph for the variant on screen, falling back to the product's featured image */
  function baseImage() {
    var v = currentVariant();
    return (v && v.img) || BASE_IMAGE;
  }
  function restore() { var b = baseImage(); if (b) swapHero(b); }
  function handle(label) {
    var sw = parseSwatch(label);
    if (!sw) return;
    log('clicked', sw);
    if (/wood/i.test(sw.fabricType)) { log('wood, ignoring'); return; }
    if (isNative(sw)) { log('native colourway, restoring photograph'); restore(); return; }
    var url = findImage(sw);
    /* No render for this colour (e.g. another fabric family): show the photograph, never a stale render */
    if (url) swapHero(url); else restore();
  }
  function checkedSwatchLabel() {
    var input = document.querySelector(CONFIG.swatchInput + ':checked');
    return input && input.closest ? input.closest(CONFIG.swatchLabel) : null;
  }

  /* Shopify re-renders the gallery when a variant changes, which throws away whatever we put there, so the
     work is done twice: once early for responsiveness and once after the re-render has certainly landed. */
  var prevOptions = [];
  function onVariantChange() {
    CONFIG.rerenderDelays.forEach(function (d) { setTimeout(applyForVariant, d); });
  }
  function applyForVariant() {
    var before = prevOptions;
    buildLookup();
    var after = currentOptions();
    var otherChanged = false;
    for (var i = 0; i < Math.max(before.length, after.length); i++) {
      if (i !== mapKeyIndex && before[i] !== after[i]) otherChanged = true;
    }
    prevOptions = after;
    var label = checkedSwatchLabel();
    /* Only the option the map is keyed on changed (Single to Double, say): keep the customer's colour and
       redraw it at the new size. Any other option means a different swatch set, so go back to the photograph. */
    if (NESTED && !otherChanged && label) { log('same fabric, new', after[mapKeyIndex], '- reapplying colour'); handle(label); }
    else { log('variant changed, restoring photograph'); restore(); }
  }

  function allUrls() {
    var out = [];
    Object.keys(RAW).forEach(function (k) {
      var v = RAW[k];
      if (typeof v === 'string') out.push(v);
      else if (v && typeof v === 'object') Object.keys(v).forEach(function (k2) { out.push(v[k2]); });
    });
    return out;
  }
  function preload() {
    if (!CONFIG.preload) return;
    var urls = allUrls();
    var i = 0;
    function next(d) {
      while (i < urls.length && (!d || d.timeRemaining() > 4)) {
        var im = new Image(); im.src = urls[i].split('?')[0] + '?width=' + CONFIG.preloadWidth; i++;
      }
      if (i < urls.length) schedule();
    }
    function schedule() {
      if (window.requestIdleCallback) window.requestIdleCallback(next, { timeout: 4000 });
      else setTimeout(function () { next(null); }, 1200);
    }
    schedule();
  }
  /* Touch devices: Easify's hover tooltip makes iOS treat the first tap as a hover, so the swatch needed two taps.
     The snippet CSS hides that tooltip on (hover: none) devices so one tap selects; this briefly shows the
     colour name on the tapped swatch instead. */
  var lastPointer = '';
  var tipTimer = null;
  function showTapTip(label) {
    var wrap = label.closest('.tpo_image-swatches-wrapper');
    if (!wrap) return;
    document.querySelectorAll('.lt-tap-tip').forEach(function (w) { w.classList.remove('lt-tap-tip'); });
    wrap.classList.add('lt-tap-tip');
    clearTimeout(tipTimer);
    tipTimer = setTimeout(function () { wrap.classList.remove('lt-tap-tip'); }, 1600);
  }
  function init() {
    buildLookup();
    prevOptions = currentOptions();
    log('init,', NESTED ? 'per variant map' : 'single map', '- native:', NATIVE || '(none)');
    if (!getHero()) log('WARNING: no hero image matched');
    /* Delegated listeners survive Easify re-rendering its option block */
    document.addEventListener('pointerdown', function (e) { lastPointer = e.pointerType || ''; }, true);
    document.addEventListener('click', function (e) {
      var label = e.target.closest && e.target.closest(CONFIG.swatchLabel);
      if (!label) return;
      if (lastPointer === 'touch') showTapTip(label);
      setTimeout(function () { handle(label); }, 0);
    }, true);
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.matches) return;
      if (t.matches(CONFIG.swatchInput)) { var l = t.closest(CONFIG.swatchLabel); if (l) handle(l); return; }
      /* Shopify variant options: the fabric family on most products, plus Segment Selection on the modular sofa */
      if (t.matches('input[name*="Upholstery"], select[name*="Upholstery"], input[name*="main-option"], select[name*="main-option"]')) onVariantChange();
    }, true);
    preload();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, CONFIG.initDelay); });
  } else {
    setTimeout(init, CONFIG.initDelay);
  }
})();
